import {
	LOGIN_SUCCEEDED,
  LOGIN_FAILED,
	EMPLOYEE_LOADED,
	LOGOUT_SUCCEEDED,
	LOGOUT_FAILED
} from '../actions/types'

import React from 'react';

const INITIAL_STATE = {
	apiToken: null,
  error_message: null,
	employee: null,
	login_success: false,
};

export default (state = INITIAL_STATE, action) => {
	switch(action.type) {
		case LOGIN_SUCCEEDED:
			console.log("login succeeded")
			return { ...state, apiToken: action.payload, login_success: true };
    case LOGIN_FAILED:
			console.log("login failed")
  		return { ...state, error_message: "Wrong credentials", login_success: false };
		case EMPLOYEE_LOADED:
			return { ...state, employee: action.payload };
		case LOGOUT_SUCCEEDED:
			return { ...state, apiToken: null };
		case LOGOUT_FAILED:
			return { ...state, apiToken: null };
		default:
			return { ...state };
  }
}
